import React, { useContext } from 'react';
import { Section } from 'libs/growth-platform-brand-system-v2/src/components/Section';
import { BrandSystemContext } from 'libs/growth-platform-brand-system-v2/src/contexts/BrandSystemContext';
import { BlocksType } from './BlocksType';
import { prepareSectionProps } from './prepareSectionProps';
import { useFindBlock } from '../BlockComponents/ConditionalBlockComponent';

export const BlockZone = ({
  anchor,
  block: _block,
  blocks,
  heroData,
  id,
  pageId,
  doc,
  options,
  index,
}: {
  anchor?: string;
  block: any;
  blocks: any[];
  heroData?: any;
  id?: string;
  pageId?: string;
  doc?: any;
  options?: any;
  index: number;
}) => {
  const { language } = useContext(BrandSystemContext);
  // For conditional blocks, return null if no block is found for the current query params
  const block = useFindBlock(_block);
  if (!block) {
    return null;
  }

  const {
    topPadding,
    bottomPadding,
    disableTopPadding,
    disableBottomPadding,
    forceCodeColor,
    backgroundColor,
    as,
    isDark,
    isContained,
    className,
  }: any = prepareSectionProps({ block, blocks, pageId, index, doc });

  return (
    <Section
      blockType={block.__typename}
      isContained={isContained}
      id={anchor || id}
      as={as}
      topPadding={disableTopPadding ? 'disabled' : topPadding}
      bottomPadding={disableBottomPadding ? 'disabled' : bottomPadding}
      backgroundColor={backgroundColor}
      forceCodeColor={forceCodeColor}
      isDark={isDark}
      className={className}
    >
      <BlocksType
        block={block}
        pageId={pageId}
        heroData={heroData}
        index={index}
        id={id}
        locale={language}
        options={options}
        doc={doc}
      />
    </Section>
  );
};
